<template>
  <div>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <menu-aside></menu-aside>
    <ConfirmOrders v-if="hasJiuJing"></ConfirmOrders>
    <header class="header">
      <Select v-if="!hideBizLines" v-model="currentBizLine" class="bizline-select" @on-change='bizLineChanged'>
        <Option v-for="bizLine in authBizLines" :key="bizLine.value" :value="bizLine.value">{{bizLine.name}}</Option>
      </Select>
      <section class="account-actions">
        <Dropdown placement="bottom-end" trigger="click" @on-click='dropDownMenuClicked'>
          <a href="javascript:void(0)">
            {{userName}}
            <Icon type="arrow-down-b"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem v-for="menu in userMenus" :key="menu.id" :name="menu.id">
              <a href="javascript:void(0)">{{menu.name}}</a>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <span class="account-type">{{accountType}}</span>
        <span class="msg-center">
          <msg-center />
          <voice-notification />
        </span>
        <span class="presale-chat" @click="openPreSale" title="售前服务">
          <Icon :type="'turbo-ui-headset'" />
        </span>
        <span v-if="hasWalletList" class="my-wallet" @click="navToWalletList" title="我的钱包">
          <Icon :type="'turbo-ui-wallet'" />
        </span>
      </section>
    </header>
    <div class="work-space">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
  import menuAside from "views/aside/main.vue";
  import { rootRouteName, accountTypeMap } from "config/menuConfig";
  import { getAuthBizLines } from "utils/menu";
  import wsPush from "utils/WebSocketMesssage";
  import { getAccountPermission } from "api/common";
  import { insertCookie } from "api/tripNotify.js";
  import { mapActions } from "vuex";
  import { iHost, webSocketHost } from "config/env.conf";
  import msgCenter from "components/message/messageCenter.vue";
  import ToastAndAlertNotification from "components/message/toastAndAlertNotification.js";
  import VoiceNotification from "components/message/voiceNotification.vue";
  import ConfirmOrders from 'components/ConfirmOrders/ConfirmOrders'
  import { NoticeIcon } from "@hfe/turbos";
  let preSaleUrl = "";
  switch (ENV) {
    case "production":
      preSaleUrl = "//fuwu.meituan.com/";
      break;
    case "staging":
      preSaleUrl = "//fuwu.hfe.st.meituan.com/";
      break;
    default:
      preSaleUrl = `${iHost}/awp/hfe/hotel-fe-chat/index.html`;
  }
  preSaleUrl += "#/chat/business";
  const walletEntranceCode = 1;
  export default {
    data: function() {
      return {
        authBizLines: [],
        currentBizLine: null,
        unregisterRouteHookFn: null,
        userName: null,
        accountType: null,
        userMenus: [
          { name: "账号管理", id: "1" },
          { name: "我的信息", id: "3" },
          { name: "系统设置", id: 4 },
          { name: "退出登录", id: "2" }
        ],
        spinShow: false,
        hideBizLines: false,
        hasWalletList: false,
        timerId: null,
        toastAndAlertNotificationInstance: false,
        hasJiuJing: false,
          push: null,
          webSocketRetryLimit: 4
      };
    },
    async created() {
      let bizUser = this.$store.state.bizUser;
      if (bizUser) {
        this.userName = bizUser.userName;
        if (!bizUser.freeLogin) {
          this.accountTypeCode = bizUser.accountType;
          this.accountType = accountTypeMap[this.accountTypeCode];
        } else {
          this.accountType = "免密登录";
        }
      }
      let routes = this.$router.options.routes;
      let bizLines = getAuthBizLines(routes, bizUser);
      this.hasJiuJing = bizLines.find(bizLine => {
        return bizLine.value === "jiujinghome";
      })
        ? true
        : false;
      if (bizLines && bizLines.length) {
        this.authBizLines = bizLines;
        let currentRoute = this.$route;
        let matches = currentRoute.matched;
        if (matches && matches[0] && matches[0].name === rootRouteName) {
          let bizLineRoute = matches[1];
          if (bizLineRoute && bizLineRoute.meta) {
            if (bizLineRoute.meta.notBizMenu) {
              this.hideBizLines = true;
            } else {
              this.hideBizLines = false;
              this.currentBizLine = bizLineRoute.meta.name;
            }
          } else {
            this.navToDefaultBizLine();
          }
        }
      } else {
        this.$router.push({ name: "unauthorized" });
      }
      this.updateHeaderLinks();
      this.unregisterRouteHookFn = this.$router.beforeEach((to, from, next) => {
        if (to.name === rootRouteName) {
          this.navToDefaultBizLine(next);
        } else {
          let matches = to.matched;
          if (matches && matches[0] && matches[0].name === rootRouteName) {
            let bizLineRoute = matches[1];
            if (bizLineRoute && bizLineRoute.meta) {
              if (bizLineRoute.meta.notBizMenu) {
                this.hideBizLines = true;
              }
              this.$nextTick(() => {
                this.currentBizLine = bizLineRoute.meta.name;
              });
            }
          }
          this.updateHeaderLinks(to);
          next();
        }
      });
      getAccountPermission(walletEntranceCode)
        .then(response => {
          let entrances = response.data || [];
          let walletEntrance = entrances.find(entrance => {
            return entrance.entranceCode === walletEntranceCode;
          });
          if (!walletEntrance || walletEntrance.checked === 1) {
            this.hasWalletList = true;
          }
        })
        .catch(err => {
          let msg = (err && err.data && err.data.message) || "获取用户权限出错";
          console.error(msg);
        });

      await this.connectMsgSYS();
        /*
      if (window && window.setInterval && !this.timerId) {
        this.getCount();
        this.timerId = window.setInterval(() => this.getCount(), 30000);
      }
      */
      if (!this.toastAndAlertNotificationInstance) {
        this.toastAndAlertNotificationInstance = new ToastAndAlertNotification(
          this.$Modal,
          this.$Notice,
          this.$router
        );
      }
    },
    components: {
      menuAside,
      NoticeIcon,
      tab: NoticeIcon.Tab,
      msgCenter,
      VoiceNotification,
      ConfirmOrders
    },
    destroyed() {
      if (this.unregisterRouteHookFn) {
        this.unregisterRouteHookFn();
      }
      if (this.timerId) {
        window.clearInterval(this.timerId);
        this.timerId = null;
      }
    },
    methods: {
        ...mapActions(["doLogout", "getCount", "setCount"]),
      error(message) {
        this.$Modal.error({
          title: "提示",
          content: message
        });
      },
        async connectMsgSYS() {
            if (!this.push && this.webSocketRetryLimit > 0) {
                try {
                    await insertCookie();
                    this.push = new wsPush({
                        url: `${ENV === 'production'?'wss':'ws'}:${webSocketHost}/trip-notify/webpush/msg`,
                        appkey: 'com.sankuai.trip.tdc.tripnotify',
                        bizAccountId: this.$store.state.bizUser.userId,
                        forcePoll: false,
                    });

                    this.push.on('msg', (msg) => {
                        if (msg.length > 0) {
                            this.setCount(JSON.parse(msg));
                            //收到消息，说明websocket正常
                            if (this.webSocketRetryLimit !== 4) this.webSocketRetryLimit = 4;
                            if (this.timerId) {
                                window.clearInterval(this.timerId);
                                this.timerId = null;
                            }
                        }
                    })

                    // 降级
                    this.push.on('poll', reason => {
                        this.owlAddError('poll', reason)
                        this.messagePoll();
                    })
                } catch (e) {
                    this.owlAddError('poll', e.message);
                    this.messagePoll();
                }
            }
        },
        async messagePoll() {
            if (this.push) this.push.off('msg')
            if (window && window.setInterval && !this.timerId) {
                if (await this.getCount()) {
                    this.startCount();
                }
            }
            if (this.webSocketRetryLimit > 0 && window && window.setTimeout) {
                this.push = null;
                this.webSocketRetryLimit --;
                this.owlAddError('reBoot', '')
                window.setTimeout(async ()=>await this.connectMsgSYS(), 1000*60*3)
            }
        },
        startCount() {
            this.timerId = window.setInterval(async () => {
                if (!(await this.getCount())) {
                    clearInterval(this.timerId);
                    this.timerId = null;
                }
            }, 30000);
        },
        owlAddError(msg, reason) {
            if (Owl) {
                Owl.addError(`WebSocket - ${msg} - ${reason}`, {
                    level: 'info',
                    combo: false,
                })
            }
        },
      updateHeaderLinks(route) {
        let targetRoute = route || this.$route;
        let matches = (targetRoute && targetRoute.matched) || [];
        if (matches && matches.length > 2) {
          this.matches = matches.filter((key, index) => {
            return index > 1;
          });
        }
      },
      openPreSale() {
        if (preSaleUrl) {
          window.open(preSaleUrl, "_blank");
        }
      },
      navToWalletList() {
        this.$router.push({ name: "purseList" });
      },
      dropDownMenuClicked(id) {
        switch (Number.parseInt(id, 10)) {
          case 1:
            if (this.accountTypeCode === 1) {
              this.$router.push({ name: "adminAccount" });
            } else {
              this.$router.push({ name: "subAccount" });
            }
            break;
          case 2:
            this.spinShow = true;
            this.doLogout()
              .then(() => {
                window.location.href =
                  window.location.href.split("#")[0] + "#/login";
                window.location.reload();
                this.spinShow = false;
              })
              .catch(err => {
                let msg = (err && err.message) || "登出失败";
                this.error(msg);
                this.spinShow = false;
              });
            break;
          case 3:
            this.$router.push({ name: "jiujingauthInfo" });
            break;
          case 4:
            this.$router.push({ name: "systemSetting" });
            break;
          default:
            break;
        }
      },
      navToRoute(name) {
        this.$router.push({ name });
      },
      bizLineChanged(name) {
        let router = this.$router;
        let route = router.currentRoute;
        let hrefObj = router.resolve({ name });
        if (hrefObj) {
          let lineHomeHash = hrefObj.href;
          if (lineHomeHash) {
            let currentHash = window.location.hash;
            if (currentHash && currentHash.includes(lineHomeHash)) {
              return;
            }
          }
        }
        this.$router.push({ name });
      },
      navToDefaultBizLine(next) {
        this.$nextTick(() => {
          this.hideBizLines = false;
          this.currentBizLine = this.authBizLines[0].value;
          let pathObj = { name: this.currentBizLine };
          if (!next) {
            this.$router.push(pathObj);
          } else {
            next(pathObj);
          }
        });
      }
    },
    computed: {
      unreadMap() {
        return this.$store.state.unreadMap;
      }
    },
    watch: {
      unreadMap: function() {
        if (this.toastAndAlertNotificationInstance) {
          this.toastAndAlertNotificationInstance.onUnreadChange(
            this.$store.state.unreadMap
          );
        }
      }
    }
  };
</script>
<style lang="scss">
@import "./../turbo.custom.scss";
.header {
  box-shadow: inset 0 -0.5px 0 0 #dce3ea;
  .nav-links {
    .tbo-icon-turbo-ui-arrow-right {
      color: #c0ccdb;
    }
    a.route-link {
      font-size: 18px;
      line-height: 22px;
      text-align: left;
      color: #333d48;
      &:hover {
        color: #3dc6b6;
      }
    }
  }
  position: fixed;
  background-color: #fff;
  right: 0;
  top: 0;
  z-index: 6;
  left: 160px;
  border-width: 0;
  border-radius: 0;
  margin-bottom: 0;
  height: 86px;
  display: flex;
  align-items: center;
  .bizline-select {
    flex-basis: 132px;
    margin: 24px 20px;
    user-select: none;
    .tbo-select-dropdown {
      max-height: none;
    }
    & .tbo-select-item {
      line-height: 22px;
      padding: 7px 20px;
      font-size: 14px !important;
    }
    &.tbo-select-visible
      .tbo-select-selection
      .tbo-select-arrow:nth-of-type(2) {
      transform: translateY(-50%) rotate(180deg);
    }
    &.tbo-select .tbo-select-selection {
      height: 38px;
      & .tbo-select-arrow {
        font-size: 22px;
        color: #c0ccdb;
        transform: translateY(-50%);
        margin-top: 0;
        right: 19px;
      }
    }
    &.tbo-select-single .tbo-select-selection .tbo-select-selected-value {
      font-size: 18px;
      font-weight: 500;
      line-height: 38px;
      height: 38px;
      padding-left: 20px;
      padding-right: 40px;
      color: #333d48;
      font-family: PingFangSC;
    }
  }
  .account-actions {
    flex-grow: 1;
    margin-right: 40px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }
  .account-type {
    background-color: #545e80;
    padding: 0 5px;
    height: 18px;
    display: block;
    border-radius: 9px;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    font-weight: 600;
    margin-right: 10px;
    color: #fafcff;
    user-select: none;
    font-family: PingFangSC;
  }
  .msg-center {
    margin-right: 26px !important;
  }
  .tbo-dropdown-menu {
    min-width: 88px;
    padding: 5px 0;
    & .tbo-dropdown-item {
      text-align: center;
    }
  }
  .msg-center,
  .presale-chat,
  .my-wallet,
  .old-version {
    display: block;
    margin-right: 16px;
    padding: 10px;
    transition: all 0.2s linear;
    &:hover {
      border-radius: 2px;
      background-color: rgba(84, 94, 128, 0.1);
    }
    cursor: pointer;
    .tbo-icon {
      font-size: 22px;
      line-height: 1em;
    }
  }
  .account-actions {
    & a {
      color: #60666e;
      &:hover,
      &:focus {
        color: #37a6fc;
        text-decoration: none;
      }
    }
  }
}
.work-space {
  position: fixed;
  top: 86px;
  left: 160px;
  right: 0;
  bottom: 0;
  padding: 0;
  overflow: auto;
}
</style>




// WEBPACK FOOTER //
// Main.vue?1ec39656